import React from 'react';
import { isEmpty } from 'lodash';
import { ErrorListWrapper, ErrorHeader, ErrorList } from './styled';
import { getMetricDisplayName } from '@src/utils/metrics';

const ShowErrorBox = ({ metricKey, errorList }) => {
  if (metricKey !== 'NA') {
    const isEmptyErrorList = isEmpty(errorList);
    const displayName = getMetricDisplayName({ metricKey });
    return (
      <ErrorListWrapper>
        <ErrorHeader>{displayName}</ErrorHeader>
        {isEmptyErrorList ? (
          <ErrorList>No errors to display</ErrorList>
        ) : (
          <React.Fragment key="cards">
            {errorList.map((error) => (
              <ErrorList key={error}>{error}</ErrorList>
            ))}
          </React.Fragment>
        )}
      </ErrorListWrapper>
    );
  } else {
    return <div>-</div>;
  }
};

export default ShowErrorBox;
